export const adminRoles = {
  admin: 'Администратор',
  supervisor: 'Менеджер',
}
